import { translate, useIsLoading } from '@avensia/excite';
import { styled } from '@glitz/react';
import * as React from 'react';
import { Pagination } from 'webapp/product-listing/Pagination';
import { FeedbackControlledButton } from 'webapp/components/button';
import { isSvenssons, Theme } from 'webapp/theme';
import { Status } from '@avensia/excite-ui';
import { NnTestIdProps } from 'webapp/shared/test-ids';

type PropType = Excite.ContentApi.PaginationApiModel & {
  onChangePage: () => void;
};

export const InfiniteScrollWithPagination = React.memo(
  (props: PropType & { productCount: number; bindInfiniteScroll: () => void }) => {
    const isLoading = useIsLoading();
    return (
      <Base>
        <PageText>
          {translate(t => t.productListing.infinitePaginationText, {
            ['current_page']: props.productCount,
            ['total_page_count']: props.total,
          })}
        </PageText>
        {props.currentPage !== props.pageCount && (
          <ShowMoreProducts
            state={isLoading ? { status: Status.Pending, disabled: true } : { status: Status.Default, disabled: false }}
            as={isSvenssons ? Theme.Primary : Theme.Secondary}
            onClick={props.bindInfiniteScroll}
            {...NnTestIdProps.PlpPaginationShowMoreButton}
          >
            {translate(t => t.productListing.showMoreProducts)}
          </ShowMoreProducts>
        )}
        {props.productCount !== props.total && <Pagination {...props} />}
      </Base>
    );
  },
);

const ShowMoreProducts = styled(FeedbackControlledButton, {
  width: 230,
  fontSize: t => t.sharedFontSize.xs,
  margin: { top: t => t.sharedSpacing.l, bottom: t => t.sharedSpacing.m },
});

const Base = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginBottom: t => t.sharedSpacing.xl,
});

const PageText = styled.div({
  fontSize: t => t.sharedFontSize.xs,
});
